import Alert, { AlertColor, AlertProps } from '@mui/material/Alert';

export type AlertComponentColor = AlertColor | 'secondary' | 'primary';

interface AlertComponentProps extends Omit<AlertProps, 'color'> {
  color?: AlertComponentColor;
}

const AlertComponent = (props: AlertComponentProps) => {
  return <Alert {...(props as AlertProps)} />;
};

export default AlertComponent;
